<div class="staticPage">
    <!-- <app-loading *ngIf="loading"></app-loading> -->
    <div *ngIf="loading" class="position-absolute loading">
        <app-loading *ngIf="loading"></app-loading>
    </div>
    <div
        *ngIf="staticContent && staticContent.type != 'iframe_url'"
        [ngClass]="{ container: !router.url.includes('nstall') }"
    >
        <h2 *ngIf="staticContent.show_title" class="text-center">
            {{
                lang == "ar" ? staticContent?.title_ar : staticContent?.title_en
            }}
        </h2>
        <div
            [innerHTML]="
                lang == 'ar'
                    ? staticContent?.content_ar
                    : staticContent?.content_en
            "
            class="content"
        ></div>
    </div>
    <div
        class="iframe-type"
        *ngIf="staticContent && staticContent.type == 'iframe_url'"
    >
        <h2 *ngIf="staticContent.show_title" class="text-center">
            {{
                lang == "ar" ? staticContent?.title_ar : staticContent?.title_en
            }}
        </h2>
        <iframe
            [src]="
                lang == 'ar'
                    ? staticContent?.iframe_url_ar
                    : staticContent?.iframe_url_en
            "
            frameborder="0"
        ></iframe>
    </div>
</div>
